import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const WaveIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon">
        <path
          id="Vector 426"
          d="M1.5 7.8814C2 7.71473 3.76243 7.09399 4.5 4.8813C6 0.381348 12 0.381374 12.5 5.3814C12.3333 4.54803 11.1389 3.47018 10 4.3813C8.2259 5.8006 9.5 8.8813 15 8.8813M6.5 6.38133C6.5 9.88135 9.5 11.8813 14 11.8813M4.5 9.38133C4.5 10.8813 6.5 12.8813 8 12.8814"
          stroke={fillColor || '#383838'}
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export { WaveIcon };
